import { Box, Container, Stack, Typography } from '@mui/material';
import RewardsMgmtGuide from '@src/lib/data/rewards-mgmt-guide.json';
import { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import TableOfContents from './contents';
import Toolbar from './toolbar';

const TNC_ITEMS = [
	"Gameworkz provides the raffle draw feature as an optional client-controlled module. All operational, legal, and verification responsibilities rest with the operator.",
	"The operator is responsible for all data validation of participants, e.g., checking duplicates or eligibility of winners.",
	"Operators are responsible for all content published to the provided rewards page, and responsible for meeting local privacy and data-protection requirements.",
	"The RNG tool is for promotional use only and is not certified for regulated gaming outcomes.",
	"Re-draws are managed entirely by the operator using the RNG feature, Gameworkz plays no role in determining eligibility or verifying winners.",
];

export default function PortalGuideRewardsManagement() {
	const [search, setSearch] = useState<string>("");

	const newSections = useMemo(() => {
		return RewardsMgmtGuide.filter((section) => {
			const { title } = section;
			return title.toLowerCase().includes(search.toLowerCase()) && title !== "How to Check Redeem Transactions and Update Redeem Status";
		});
	}, [search]);

	return (
		<>
			<Helmet>
				<title> Portal Guide - Rewards Management </title>
			</Helmet>
			<Container>
				<Typography fontSize={14} fontWeight={700} mb={1}>
					Terms and Conditions of use for Gameworkz Raffle Draw feature.
				</Typography>
				<Typography fontSize={14}>
					By using the Gameworkz raffle draw feature you agree to the following:
				</Typography>
				<Stack component="ol" spacing={0.75} sx={{ pl: 0, m: 0, mb: 2, mt: 0.5, ml:2, listStyle: "none" }}>
					{TNC_ITEMS.map((item, i) => (
						<Box component="li" key={i} sx={{ display: "flex" }}>
							<Typography fontSize={12} minWidth={20}>
								{String.fromCharCode(97 + i)}.
							</Typography>
							<Typography fontSize={12}>{item}</Typography>
						</Box>
					))}
				</Stack>
				<Toolbar search={search} onChange={setSearch} />
				<TableOfContents options={newSections}/>
			</Container>
		</>
	)
}
